import { cn } from '@/lib/utils'

/** A 0–100 measure (`text` replaces the number beside the bar: "12.3%") as a short bar with its number: popularity, difficulty.
 *  The number is always there, so the bar's colour carries nothing alone.
 *  A measure of 0 is "not measured" and reads as a dash. */
export function MiniBar({ value, label, fill = 'bg-chart-1', text, className }: { value: number; label: string; fill?: string; text?: string; className?: string }) {
  const measured = value > 0
  const width = Math.max(0, Math.min(100, value))
  return (
    <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap tabular-nums', className)} title={`${label} ${measured ? (text ?? value) : '미측정'}`}>
      <span aria-hidden className="h-1.5 w-10 shrink-0 overflow-hidden rounded-full bg-muted">
        <span className={cn('block h-full rounded-full', fill)} style={{ width: `${width}%` }} />
      </span>
      <span className={cn(text ? 'min-w-[3rem]' : 'w-6', 'text-right', !measured && 'text-muted-foreground')}>
        <span className="sr-only">{label} </span>
        {measured ? (text ?? value) : '—'}
      </span>
    </span>
  )
}
